import { render, staticRenderFns } from "./ModalCheckBalance.vue?vue&type=template&id=27faa46a&scoped=true&"
import script from "./ModalCheckBalance.vue?vue&type=script&lang=js&"
export * from "./ModalCheckBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27faa46a",
  null
  
)

export default component.exports